export default {
  state: {
    userData: {},
  },

  getters: {
    getUserData(state) {
      return state.userData;
    },
  },

  mutations: {
    setUserData(state, data) {
      const isNull = data === null;

      state.userData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
        social_name: !isNull ? data.social_name : "",
        registration: !isNull ? data.registration : "",
        polyclinic_ids: !isNull ? data.polyclinic_ids : [], 
        county_id: !isNull ? parseInt(data.county_id) : "",
        county_name: !isNull ? data.county?.name : "",
        main_phone: !isNull ? data.main_phone : "",
        alternative_phone: !isNull ? data.alternative_phone : "",
        cell_phone: !isNull ? data.cell_phone : "",
        email: !isNull ? data.email : "",
        cpf: !isNull ? data.cpf : "",
        profile: !isNull ? parseInt(data.profile_id) : "",
      };
    },
  },

  actions: {
    changeUserData(context, infos) {
      context.commit("setUserData", infos);
    },
  },
};
